var map = {
	"./erp-active.svg": "6936",
	"./erp.svg": "7a3b",
	"./home-1.svg": "3c3f",
	"./home-2.svg": "85d5",
	"./home-3.svg": "f05b",
	"./home-4.svg": "76e8",
	"./home-5.svg": "65c3",
	"./home-6.svg": "2821",
	"./isv-active.svg": "fdf6",
	"./isv.svg": "c6c2",
	"./logo-international-white.svg": "b052",
	"./logo-international.svg": "3dbf",
	"./serve-active.svg": "4ffd",
	"./serve.svg": "b6390"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5fce";